var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJ1772(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:#71778a;}.b{fill:#c9cfe3;}.c{fill:#353841;}.d,.e,.f{stroke:none;}.e{fill:#cad0e4;}.g{filter:url(#i);}.h{filter:url(#g);}.i{filter:url(#e);}.j{filter:url(#c);}.k{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 13,
    y: 21.5,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 19,
    y: 6.5,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 24,
    y: 17.5,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 4,
    y: 17.5,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 7,
    y: 6.5,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-386 -676)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(386 676)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 21 40.5 C 18.36685943603516 40.5 15.81326961517334 39.9846305847168 13.41018009185791 38.96820831298828 C 11.08831024169922 37.98614120483398 9.002750396728516 36.57991027832031 7.211420059204102 34.78858184814453 C 5.420090198516846 32.99724960327148 4.01386022567749 30.91168975830078 3.031790018081665 28.58982086181641 C 2.015369892120361 26.18672943115234 1.5 23.63314056396484 1.5 21 C 1.5 18.36685943603516 2.015369892120361 15.81326961517334 3.031790018081665 13.41018009185791 C 4.01386022567749 11.08831024169922 5.420090198516846 9.002750396728516 7.211420059204102 7.211420059204102 C 9.002750396728516 5.420090198516846 11.08831024169922 4.01386022567749 13.41018009185791 3.031790018081665 C 15.81326961517334 2.015369892120361 18.36685943603516 1.5 21 1.5 C 23.63314056396484 1.5 26.18672943115234 2.015369892120361 28.58982086181641 3.031790018081665 C 30.91168975830078 4.01386022567749 32.99724960327148 5.420090198516846 34.78858184814453 7.211420059204102 C 36.57991027832031 9.002750396728516 37.98614120483398 11.08831024169922 38.96820831298828 13.41018009185791 C 39.9846305847168 15.81326961517334 40.5 18.36685943603516 40.5 21 C 40.5 23.63314056396484 39.9846305847168 26.18672943115234 38.96820831298828 28.58982086181641 C 37.98614120483398 30.91168975830078 36.57991027832031 32.99724960327148 34.78858184814453 34.78858184814453 C 32.99724960327148 36.57991027832031 30.91168975830078 37.98614120483398 28.58982086181641 38.96820831298828 C 26.18672943115234 39.9846305847168 23.63314056396484 40.5 21 40.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 21 3 C 16.19202995300293 3 11.67182922363281 4.872329711914063 8.272079467773438 8.272079467773438 C 4.872329711914063 11.67182922363281 3 16.19202995300293 3 21 C 3 25.80797004699707 4.872329711914063 30.32817077636719 8.272079467773438 33.72792053222656 C 11.67182922363281 37.12767028808594 16.19202995300293 39 21 39 C 25.80797004699707 39 30.32817077636719 37.12767028808594 33.72792053222656 33.72792053222656 C 37.12767028808594 30.32817077636719 39 25.80797004699707 39 21 C 39 16.19202995300293 37.12767028808594 11.67182922363281 33.72792053222656 8.272079467773438 C 30.32817077636719 4.872329711914063 25.80797004699707 3 21 3 M 21 0 C 32.59798049926758 0 42 9.402019500732422 42 21 C 42 32.59798049926758 32.59798049926758 42 21 42 C 9.402019500732422 42 0 32.59798049926758 0 21 C 0 9.402019500732422 9.402019500732422 0 21 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(391 681)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(1, 0, 0, 1, 386, 676)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(16 24.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(1, 0, 0, 1, 386, 676)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(22 9.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, 386, 676)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(27 20.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 4 7.25 C 2.207940101623535 7.25 0.75 5.792059898376465 0.75 4 C 0.75 2.207940101623535 2.207940101623535 0.75 4 0.75 C 5.792059898376465 0.75 7.25 2.207940101623535 7.25 4 C 7.25 5.792059898376465 5.792059898376465 7.25 4 7.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 4 1.5 C 2.621500015258789 1.5 1.5 2.621500015258789 1.5 4 C 1.5 5.378499984741211 2.621500015258789 6.5 4 6.5 C 5.378499984741211 6.5 6.5 5.378499984741211 6.5 4 C 6.5 2.621500015258789 5.378499984741211 1.5 4 1.5 M 4 0 C 6.209139823913574 0 8 1.790860176086426 8 4 C 8 6.209139823913574 6.209139823913574 8 4 8 C 1.790860176086426 8 0 6.209139823913574 0 4 C 0 1.790860176086426 1.790860176086426 0 4 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, 386, 676)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(7 20.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 4 7.25 C 2.207940101623535 7.25 0.75 5.792059898376465 0.75 4 C 0.75 2.207940101623535 2.207940101623535 0.75 4 0.75 C 5.792059898376465 0.75 7.25 2.207940101623535 7.25 4 C 7.25 5.792059898376465 5.792059898376465 7.25 4 7.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 4 1.5 C 2.621500015258789 1.5 1.5 2.621500015258789 1.5 4 C 1.5 5.378499984741211 2.621500015258789 6.5 4 6.5 C 5.378499984741211 6.5 6.5 5.378499984741211 6.5 4 C 6.5 2.621500015258789 5.378499984741211 1.5 4 1.5 M 4 0 C 6.209139823913574 0 8 1.790860176086426 8 4 C 8 6.209139823913574 6.209139823913574 8 4 8 C 1.790860176086426 8 0 6.209139823913574 0 4 C 0 1.790860176086426 1.790860176086426 0 4 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, 386, 676)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(10 9.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ1772);
export default __webpack_public_path__ + "static/media/j1772.48cda05276cd2f87d593cf764e376fab.svg";
export { ForwardRef as ReactComponent };